<template>
  <div class="section">
    <div class="section-head">
      <img src="~@/assets/img/itles-webapp-videoClass/title-zj.png" alt />
    </div>
    <div class="section-conect">
      <p>
        <span class="name">{{ name }}</span>
        <span v-if="type" class="type">{{ type }}</span>
      </p>
      <p class="des">{{ introduce }}</p>
      <van-image
        v-if="teacherImg"
        class="teacher"
        fit="cover"
        :src="teacherImg"
        alt
      >
        <template v-slot:error>加载失败</template>
      </van-image>
    </div>
  </div>
</template>
<script>
export default {
  props: ["name", "type", "introduce", "teacherImg"],
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.section-head {
  img {
    display: block;
    width: tovw(368);
    height: tovw(48);
    margin: tovw(40) auto;
    margin-top: tovw(80);
  }
}
.bg {
  display: block;
  width: 100%;
  height: tovw(160);
  margin: 0 auto;
}
.section-conect {
  background: rgba(255, 255, 255, 1)
    url(~@/assets/img/itles-webapp-videoClass/zj_bg.png) no-repeat;
  background-position: tovw(330) 0;
  background-size: tovw(334) tovw(88);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  border-radius: tovw(24);
  padding: tovw(40);
  position: relative;
  p {
    overflow: hidden;
  }
  .des {
    margin-top: tovw(40);
    font-size: tovw(26);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.6);
    line-height: tovw(40);
    width: tovw(414);
    height: tovw(190);
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
  span {
    display: block;
    float: left;
    height: tovw(48);
    line-height: tovw(48);
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .name {
    font-size: tovw(36);
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
  }
  .type {
    margin-top: tovw(4);
    font-size: tovw(24);
    font-weight: 300;
    color: rgba(0, 0, 0, 0.8);
    padding-left: tovw(50);
    position: relative;
  }
  .type::after {
    display: block;
    content: "";
    position: absolute;
    width: 1px;
    height: tovw(36);
    top: tovw(6);
    left: tovw(24);
    border-left: 1px solid #ccc;
  }
  .teacher {
    position: absolute;
    width: tovw(192);
    height: tovw(320);
    bottom: 0;
    right: 0;
  }
}
</style>
